module.exports = __webpack_public_path__ + "img/logo-V2-2022.bc5ec77e.png";